import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { inject, observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import ProductAvailabilityLabel from 'src/components/productAvailabilityLabel';
import RootStore from 'src/stores/RootStore';
import { TProductModel } from 'src/stores/types/ProductTypes';

interface SelectCarrierProps {
    store?: typeof RootStore.Type;
    selectedCarrierCode: string;
    setSelectedCarrierCode: (selected: string) => void;
}

const SelectCarrier = inject('store')(
    observer(({ store, selectedCarrierCode, setSelectedCarrierCode }: SelectCarrierProps) => {
        const carrierList: TProductModel[] | [] = store?.products.carrierList;
        const [isOpen, setOpen] = useState(false);

        useEffect(() => {
            if (carrierList?.length) {
                // No carrier by default
                setSelectedCarrierCode('empty');
            }
        }, [carrierList]);

        if (!carrierList?.length) {
            return null;
        }

        const getOption = (value: string) => {
            const foundOption = carrierList.find(part => part.id === value);
            return foundOption ? (
                foundOption.productInformation.name
            ) : (
                <span>
                    <FormattedMessage id="product.carrier.empty" />
                </span>
            );
        };

        return (
            <FormControl variant="standard" sx={{ margin: '10px 0 10px', width: '100%' }}>
                <InputLabel htmlFor="carrier-item">
                    <FormattedMessage id="select.carrier" />
                </InputLabel>
                <Select
                    data-testid="carrierSelector"
                    labelId="carrier-item"
                    open={isOpen}
                    onOpen={() => setOpen(true)}
                    onClose={() => setOpen(false)}
                    value={selectedCarrierCode}
                    name="selectedCarrierCode"
                    displayEmpty={false}
                    renderValue={(value: any) => getOption(value)}
                    onChange={e => setSelectedCarrierCode(e.target.value as string)}
                    sx={{ overflow: 'hidden' }}
                >
                    <MenuItem key="empty" value="empty" data-testid="no-carrier">
                        <FormattedMessage id="product.carrier.empty">{text => <em>{`${text}`}</em>}</FormattedMessage>
                    </MenuItem>
                    {carrierList.map((part: TProductModel) => (
                        <MenuItem
                            key={part.id}
                            value={part.id}
                            data-testid={`carrier-${part.id}`}
                            style={{ display: 'flex', justifyContent: 'space-between' }}
                            disabled={!part.productInformation.inStock && !part.productInformation.availableFrom}
                        >
                            <span>{part.productInformation.name}</span>
                            <ProductAvailabilityLabel
                                inStock={part.productInformation.inStock}
                                availableFrom={part.productInformation.availableFrom}
                                stockQuantity={part.productInformation.stockQuantity}
                            />
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        );
    }),
);

export default SelectCarrier;
